export const COI_EXPS_SET = 'COI_EXPS_SET';
export const COI_EXP_SET = 'COI_EXP_SET';
export const COI_EXP_DOCS_SET = 'COI_EXP_DOCS_SET';
export const LIABILITIES_SET = 'LIABILITIES_SET';
export const COI_EXP_DOCS_ADD = 'COI_EXP_DOCS_ADD';
export const COI_EXP_DOCS_UPDATE = 'COI_EXP_DOCS_UPDATE';
export const COI_EXP_DOCS_DESTROY = 'COI_EXP_DOCS_DESTROY';



// WEBPACK FOOTER //
// ./src/components/admin/projects/details/project-coi-exps/store/action-types.js